module.exports = __webpack_public_path__ + "img/pathway_crohns_disease.76cc9c97.png";